import _ from 'lodash';
import APIS from '../../../common/APIs';
import CommonUtil from '../../../common/CommonUtil';

export const CAROUSEL_RESPONSIVE = {
    mobile768: {
        breakpoint: { min: 768, max: 800 },
        items: 3,
        slidesToSlide: 1
    },
    mobile800: {
        breakpoint: { min: 800, max: 1024 },
        items: 3,
        slidesToSlide: 1
    },
    desktop1024: {
        breakpoint: { min: 1024, max: 1276 },
        items: 4,
        slidesToSlide: 1
    },
    desktop1276: {
        breakpoint: { min: 1276, max: 1523 },
        items: 5,
        slidesToSlide: 1
    },
    desktop1523: {
        breakpoint: { min: 1523, max: 1770 },
        items: 6,
        slidesToSlide: 1
    },
    desktop1770: {
        breakpoint: { min: 1771, max: 2400 },
        items: 7,
        slidesToSlide: 1
    },
    desktop2400: {
        breakpoint: { min: 2401, max: 5400 },
        items: 8,
        slidesToSlide: 1
    }
}

export const MASK_LIST = [
	{
		id: 'security',
		icon: 'security',
		name: '100% Safe and Reliable'
	},
	{
		id: 'payment',
		icon: 'payment',
		name: 'More than 20 Forms of Payment'
	},
	{
		id: 'time',
		icon: 'time',
		name: 'Support 24/7'
	},
	{
		id: 'associates',
		icon: 'associates',
		name: 'Join Pinnacle Affiliates'
	}
];

export const CASINO_PAGE_MAP = {
    CASINO: "CASINO",
    PROMOTIONS: "PROMOTIONS",
    VIRTUAL_SPORTS: "VIRTUAL_SPORTS",
    LIVE_CASINO: "LIVE_CASINO"
}

export const CASINO_CATEGORY_MAP  = {
    LIVE_CASINO: {
        url: '/live-casino',
        name: "Live Casino",
        icon: "live-casino-icon",
        page: CASINO_PAGE_MAP.LIVE_CASINO,
        defaultCategory: ""
    },
    SLOTS: {
        id: 1,
        url: '/casino',
        name: "Slots",
        icon: "slots-icon",
        page: CASINO_PAGE_MAP.CASINO,
        defaultCategory: ""
    },
    NEW_GAME: {
        id: 128,
        url: '/casino',
        name: "New Games",
        icon: "new-game-icon",
        page: CASINO_PAGE_MAP.CASINO,
        defaultCategory: ""
    },
    JACKPOTS: {
        id: 3,
        url: '/casino',
        name: "Jackpots",
        icon: "jackpots-icon",
        page: CASINO_PAGE_MAP.CASINO,
        defaultCategory: "Jackpot Slots"
    },
    TABLE_GAMES: {
        id: 2,
        url: '/casino',
        name: "Table Games",
        icon: "table-games-icon",
        page: CASINO_PAGE_MAP.CASINO,
        defaultCategory: ""
    },
    VIRTUAL_SPORTS: {
        url: '/vs',
        name: "Virtual Sports",
        icon: "virtual-sports-icon",
        page: CASINO_PAGE_MAP.VIRTUAL_SPORTS,
        defaultCategory: ""
    },
    PROMOTION: {
        url: '/promotion',
        name: "Promotions",
        icon: "promotions-icon",
        page: CASINO_PAGE_MAP.PROMOTIONS,
        defaultCategory: ""
    },
}

export const BANER_TYPE = {
    SPORT_LEAGUE: "SPORT_LEAGUE",
    CASINO: "CASINO",
    ESPORT: "ESPORT"
}

export const ESPORT_GAME_MAP = {
    DOTA2: {
        id: "dota2",
        name: "DOTA2",
        icon: "icon-dota2",
        urlEsportHubPath: "dota-2"
    },
    CS_GO: {
        id: "cs:go",
        name: "CS_GO",
        icon: "icon-csgo",
        urlEsportHubPath: "csgo"
    },
    LOL: {
        id: "leagueoflegends",
        name: "LOL",
        icon: "icon-leagueoflegends",
        urlEsportHubPath: "league-of-legends"
    }
}

export const LANDING_PAGE_REFRESH_TIME = 60;

export const getImageSourceURL = (url) => {
    let arrayUrl = url.split("/"),
        urlAfterSplice = "";
    arrayUrl.splice(url.split("/").length - 1, 1);
    _.forEach(arrayUrl, (v, k) => {
        if (k > 0) {
            urlAfterSplice = urlAfterSplice + "/" + v;
        }
    });
    url = `${urlAfterSplice}?fileName=${encodeURIComponent(url.split("/")[url.split("/").length - 1])}`;
    return `/${APIS.getMemberServicePath()}/${CommonUtil.getCurrentLang()}${url}`;
}

export const getImageSourceURLCaching = (url, enableCloudflare, cloudflareUrl) => {
  let arrayUrl = url.split("/"),
      urlAfterSplice = "";
  arrayUrl.splice(url.split("/").length - 1, 1);
  _.forEach(arrayUrl, (v, k) => {
      if (k > 0) {
          urlAfterSplice = urlAfterSplice + "/" + v;
      }
  });
  url = `${urlAfterSplice}?fileName=${encodeURIComponent(url.split("/")[url.split("/").length - 1])}`;
  const port = window.location.port ? `:${window.location.port}` : ""
  const fullUrl = `${window.location.protocol}//${window.location.hostname}${port}/${APIS.getMemberServicePath()}/${CommonUtil.getCurrentLang()}${url}`
  return enableCloudflare ? `${cloudflareUrl}/${fullUrl}` : `/${APIS.getMemberServicePath()}/${CommonUtil.getCurrentLang()}${url}`;
}

export const getButtonPosision = (position) => {
    if (!_.isEmpty(position)) {
        return position.replaceAll("_","-").toLowerCase();
    }
    return "";
}

export const goToButtonLink = (url) => {
    if(_.isEmpty(url)) {
        return;
    } else {
        window.location.href = url;
    }
}

export const getAllLeagueId = (leagues) => {
    let leagueIds = [];
    let sportIds = [];
    _.forEach(leagues, league => {
        if (league.leagueId == 0) {
            sportIds.push(league.sportId);
        } else {
            leagueIds.push(league.leagueId)
        }
    });
    return {sportIds: sportIds.join(), leagueIds: leagueIds.join()};
}

export const getAllSsportCodes = (esports) => {
    const esportCodes = esports.map(esport => {
        return esport.game;
    });
    return esportCodes.join();
}

export const combinedSportLeagueData = (oddsData, tempLeagueData) => {
    // Merge odds into banners data
    _.forEach(oddsData, item => {
        _.forEach(tempLeagueData, league => {
            if (league.sportId == item.sportId) {
                if (item.allLeague && league.leagueId == 0) {
                    league.leagueId = item.leagueId;
                    league.leagueName = item.leagueName;
                }
                if (league.leagueId == item.leagueId) {
                    league.oddsData = item.data;
                    league.isEarly = item.isEarly;
                    league.outright = item.outright;
                }
            }
        })
    });

    // Do not display duplicated banner
    // Prefer banner was created earlier
    _.forEach(tempLeagueData, item1 => {
        item1.willShow = true;
        _.forEach(tempLeagueData, item2 => {
            if (item1.leagueId == item2.leagueId && item1.sportId == item2.sportId && item1.createdTime < item2.createdTime) {
                item1.willShow = false;
            }

        })
    });
    return _.filter(tempLeagueData, item => {
        return item.willShow && !_.isEmpty(item.leagueName);
    });
}

export const combinedESportData = (oddsData, tempEsportData) => {
    _.forEach(oddsData, item => {
        _.forEach(tempEsportData, esport => {
            if (esport.game == item.eSportCode) {
                esport.oddsData = item.data;
                esport.isEarly = item.isEarly;
                esport.outright = item.outright;
            }
        })
    });
    return tempEsportData;
}


// WEBPACK FOOTER //
// ./src/app/components/LandingPageComponent/CommonComponent/CommonUtils.js